// Split a snippet's text into plain + <mark> segments using match offsets that
// are relative to the snippet text. Shared by text-search results and the PDF
// viewer search popover.
function Highlighted({ text, matches }) {
  if (!matches || !matches.length) return text
  const parts = []
  let cursor = 0
  matches.forEach((m, i) => {
    if (m.start > cursor) parts.push(text.slice(cursor, m.start))
    parts.push(<mark key={i}>{text.slice(m.start, m.end)}</mark>)
    cursor = m.end
  })
  if (cursor < text.length) parts.push(text.slice(cursor))
  return parts
}

export default Highlighted
